import { AdvancedVideo } from "@cloudinary/react";
import { Cloudinary } from "@cloudinary/url-gen";
import { quality } from "@cloudinary/url-gen/actions/delivery";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { Link, navigate } from "gatsby";
import { GatsbyImage, getImage, ImageDataLike } from "gatsby-plugin-image";
import * as React from "react";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import DoNotMountComponent from "../../modules/DoNotMountComponent/DoNotMountComponent";

type PropsNewCard = PropsWithChildren<{
  data: Partial<Queries.SanityHighlight>;
}>;

const NewCard: React.FC<PropsNewCard> = (props: PropsNewCard) => {
  if (!props.data) return <DoNotMountComponent sms={"NewCard"} log={props} />;
  const { t } = useTranslation("global");
  const isClickable = props.data.link?.slug;
  const slug = `/noticias/${props.data.link?.slug}/`;
  const image = getImage(props.data.asset?.image as unknown as ImageDataLike);

  const cld = new Cloudinary({
    cloud: {
      cloudName: process.env.GATSBY_CLOUDINARY_CLOUD_NAME || "",
    },
  });

  const video = cld.video(props.data.asset?.file?.public_id).delivery(quality(80));
  // .resize(fill().width(414).height(808)); TODO cuando salgan 3 no se vera bien, habrá que meter la lógica
  return (
    <div
      className={`m-new-card`}
      onClick={() => {
        isClickable && navigate(slug);
      }}
    >
      {image && (
        <GatsbyImage
          className={"new-card__cover"}
          imgClassName={"new-card__cover-img"}
          image={image}
          alt={`${props.data.asset?.name}`}
        />
      )}
      {!image && (
        <div className={`new-card__cover`}>
          <AdvancedVideo
            className={"new-card__video"}
            cldVid={video}
            cldPoster="auto"
            autoPlay={true}
            muted={true}
            loop={true}
            playsInline={true}
          />
        </div>
      )}
      {isClickable && <Link to={slug}>{props.data.asset?.name}</Link>}
      {!isClickable && <span>{props.data.asset?.name}</span>}

      {/*  <Markdown markdown={props.data.title} />*/}
    </div>
  );
};

export default NewCard;
